module.exports = __webpack_public_path__ + "media/images/thestitch-059590048bd11ec583a56b2e509fc237.svg";